// Utilitários para limpeza e manutenção de dados de sincronização de notas no localStorage
import { logDebug } from "./logger";

/**
 * Limpa dados de sincronização de outros períodos no localStorage.
 * Mantém apenas as chaves referentes ao período atual.
 *
 * Formato esperado das chaves:
 *  - grade_sync_AlunoID_TurmaID_DisciplinaID_period
 *  - visibility_AlunoID_TurmaID_DisciplinaID_period
 *
 * @param {number|string} currentPeriod - Período atualmente selecionado
 */
export const clearSyncDataForPeriodChange = (currentPeriod) => {
  try {
    logDebug(
      `Limpando dados de sincronização para mudança de período. Atual: ${currentPeriod}`
    );

    const syncKeys = [];

    // Encontrar todas as chaves relevantes de sincronização
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith("grade_sync_") || key.startsWith("visibility_"))) {
        // A chave tem formato: grade_sync_AlunoID_TurmaID_DisciplinaID_period
        const keyParts = key.split("_");
        // A última parte deve ser o período
        if (keyParts.length >= 5) {
          const keyPeriod = keyParts[keyParts.length - 1];
          if (keyPeriod !== String(currentPeriod)) {
            syncKeys.push(key);
          }
        }
      }
    }

    logDebug(
      `Encontradas ${syncKeys.length} chaves de sincronização de outros períodos para remover`
    );

    let removedCount = 0;

    syncKeys.forEach((key) => {
      try {
        localStorage.removeItem(key);
        removedCount++;
      } catch (error) {
        console.error(`Erro ao remover chave ${key}:`, error);
      }
    });

    logDebug(
      `Removidas ${removedCount} chaves de sincronização de outros períodos`
    );
  } catch (error) {
    console.error(
      "Erro ao limpar dados de sincronização para mudança de período:",
      error
    );
  }
};

/**
 * Limpa dados de sincronização expirados no localStorage.
 *
 * - Dados normais expiram em 24h
 * - Dados com falha de sincronização (failedSync = true) expiram em 7 dias
 */
export const clearExpiredSyncData = () => {
  try {
    const syncKeys = [];

    // Encontrar todas as chaves relevantes de sincronização
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith("grade_sync_") || key.startsWith("visibility_"))) {
        syncKeys.push(key);
      }
    }

    logDebug(
      `Encontradas ${syncKeys.length} chaves de sincronização para verificar`
    );

    const currentTime = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 horas
    const sevenDays = 7 * 24 * 60 * 60 * 1000; // 7 dias

    let removedCount = 0;

    syncKeys.forEach((key) => {
      try {
        const syncDataString = localStorage.getItem(key);
        if (syncDataString) {
          const syncData = JSON.parse(syncDataString);
          const syncTime = new Date(syncData.timestamp).getTime();

          if (syncData.failedSync) {
            // Dados com falha de sincronização têm tolerância maior
            if (currentTime - syncTime > sevenDays) {
              localStorage.removeItem(key);
              removedCount++;
              logDebug(
                `Removido dado não sincronizado expirado (>7 dias): ${key}`
              );
            }
          } else {
            // Dados normais expiram após 24 horas
            if (currentTime - syncTime > oneDay) {
              localStorage.removeItem(key);
              removedCount++;
              logDebug(
                `Removido dado de sincronização normal expirado (>24h): ${key}`
              );
            }
          }
        }
      } catch (error) {
        console.error(`Erro ao processar chave ${key}:`, error);
        // Em caso de erro, remover a chave para evitar problemas futuros
        localStorage.removeItem(key);
        removedCount++;
      }
    });

    logDebug(`Removidas ${removedCount} chaves de sincronização expiradas`);
  } catch (error) {
    console.error("Erro ao limpar dados de sincronização:", error);
  }
};

/**
 * Remove todas as chaves de notas/visibilidade do localStorage,
 * independente de período. Usado quando o usuário troca de período
 * na tela para garantir que não fiquem dados antigos.
 */
export const clearAllGradeSyncKeys = () => {
  const keysToRemove = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key &&
      (key.startsWith("grade_sync_") ||
        key.startsWith("visibility_") ||
        key.startsWith("grade_backup_"))
    ) {
      keysToRemove.push(key);
    }
  }

  logDebug(
    `Removendo ${keysToRemove.length} chaves do localStorage ao mudar período`
  );

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
};



